import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box } from '@as/cotopaxi';
import { DividerLineType, ReactLineStyle } from '@as-react/common-types';
import { getBoxPropsFromAEMPaddings } from '../../util/AEMUtil';
import { Divider } from '@yonderland/andes-react';
const StyleToColorMapping = {
    [ReactLineStyle.ACCENT]: 'dark',
    [ReactLineStyle.DEFAULT]: 'neutral',
    [ReactLineStyle.MEDIUM]: 'neutral',
    [ReactLineStyle.LIGHT]: 'neutral',
};
const Line = ({ paddings, borders = '', lineType, lineStyle }) => {
    const lineColor = lineStyle ? StyleToColorMapping[lineStyle] : undefined;
    const wrapperClassNames = useMemo(() => Object.values(borders).filter(Boolean).join(' '), [borders]);
    return (_jsx(Box, Object.assign({}, getBoxPropsFromAEMPaddings(paddings), { className: wrapperClassNames, children: _jsx(Divider, { style: lineType === DividerLineType.DOTTED ? 'dashed' : 'solid', color: lineColor }) })));
};
export default Line;
